import { IValidation } from "./IValidation";

export class CityValidation implements IValidation {
  private regex =
    /^[A-Za-zÁáÂâÀàÃãÄäçÇÉéÊêÈèËëíÍÎîÌìÏïÑñÓóôÔÒòÕõöÖúÚÛûùÙÜüÝý' \-.]*$/;
  private value: string = "";
  msgError = "Informe uma cidade válida.";

  isValid(value: string): boolean {
    if (!value) {
      this.value = "";
      return false;
    }
    this.value = value;
    return this.regex.test(this.value) && this.value.trim().length <= 255;
  }

  isNotValid(value: string): boolean {
    return !this.isValid(value);
  }

  getErrorMessage(): string {
    if (this.isValid(this.value) || this.value === "") {
      return "";
    }
    return this.msgError;
  }
}
